import { Policy } from "../../model/policy";

export const POLICY_PAYMENT_STORE = 'POLICY_PAYMENT_STORE';
export const POLICY_PAYMENT_FETCH_FAILED = 'POLICY_PAYMENT_FETCH_FAILED';

interface SavePolicy {
    type: typeof POLICY_PAYMENT_STORE | typeof POLICY_PAYMENT_FETCH_FAILED;
    data: Policy;
}

export type ActionType = SavePolicy;